import { useMutation } from "@tanstack/react-query";
import { useAuth } from "@/core/hooks/useAuth";
import { createPortalSession, type PortalFlow } from "@/core/api/billingApi";

/**
 * Cria a sessão do Stripe Customer Portal. `mutateAsync()` sem arg abre a troca
 * de cartão (default); `mutateAsync("subscription_update")` abre a troca de plano
 * (SA-1177). O consumidor redireciona o browser para a `url` retornada.
 */
export function useCreatePortalSession(companyId: string | null | undefined) {
  const { token } = useAuth();

  const mutation = useMutation({
    mutationKey: ["billing", "portal-session", companyId],
    mutationFn: (flow: PortalFlow = "payment_method_update") =>
      createPortalSession(token, companyId!, flow),
  });

  // Encapsula mutateAsync para aceitar flow opcional
  return {
    ...mutation,
    mutateAsync: (flow?: PortalFlow) =>
      mutation.mutateAsync(flow ?? "payment_method_update"),
  };
}
